<template>
  <div>
    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

    <v-toolbar flat class="primary">
      <h1 class="headline white--text">SEARCH LOCATIONS</h1>
    </v-toolbar>
    <v-card flat>
      <v-card-text>
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-toolbar flat color="white">
              <v-flex  xs12 sm6 md6>
             <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="locationnetworks"
                    item-text="name"
                    item-value="id"
                    v-model="locationNetworkId"
                    label="Network"
                   >
                 </v-autocomplete>
                </v-flex>

                  <v-spacer></v-spacer>
                  <v-flex  xs12 sm6 md6>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search Locations"
                    single-line
                    hide-details
                    max-width="50px"
                    class="pa-3"
                    clearable
                  ></v-text-field>
                  </v-flex>
            </v-toolbar>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-data-table
        :headers="locationSearchHeaders"
        :search="search"
        :pagination.sync="pagination"
        :items="networklocations"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
               <v-btn flat color="primary" @click="selectedLocation=props.item">
                 <v-icon>add_circle_outline</v-icon>
            </v-btn>


          </td>
          <td class="text-xs-center">{{props.item.locationDescription}}</td>
          <td class="text-xs-center">{{props.item.unitNo}}</td>
          <td class="text-xs-center">{{props.item.erfNo}}</td>
          <td class="text-xs-center">{{props.item.otherNo}}</td>
          <td
          class="text-xs-center"
          v-if="props.item.fibrePulled"
        >
          <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>
          <td class="text-xs-center">{{props.item.complexStreetName}}</td>
          <td class="text-xs-center" v-if="props.item.locationNetworkSubComplexId!==null && typeof(props.item.locationNetworkSubComplex) != 'undefined'">{{props.item.locationNetworkSubComplex.subComplexName}}</td>
          <td class="text-xs-center" v-else>{{props.item.subComplexName}}</td>
          <td class="text-xs-center">{{props.item.complexName}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ recordCalculator(props.pageStart) }} - {{ recordCalculator(props.pageStop )}} of {{ networklocations.length }} {{pageCount(totalitems, props.pageStart, props.pageStop )}}</template>
      </v-data-table>
      <template>
        <div>
          <v-btn round color="primary" @click="$emit('locationSearchCancelled')">Cancel</v-btn>
        </div>
      </template>

    </v-card>
  </div>
</template>
<script>
import Api from "@/services/Api";

export default {
  props: [
    "locationsearchmodal",
    "locationnetworks",
    "customerid",
    "networklocations",
    "totalitems"
  ],
  data() {
    return {
      pagination: {
        totalItems: this.totalitems
      },
      replacenetworklocations: [],
      customerId: null,
      locations: [],
      search: "",
      page: "",
      pages: "",
      limit: "",
      locationNetworkId: "",
      networkLocationArray: [],
      selectedLocation: "",
      searchLocations: "",
      locationSearchHeaders: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Location Description",
          align: "center",
          value: "locationDescription"
        },
        {
          text: "Unit No",
          align: "center",
          value: "unitNo"
        },
        {
          text: "Erf No",
          align: "center",
          value: "erfNo"
        },
        {
          text: "Other No",
          align: "center",
          value: "otherNo"
        },{
          text: "Passive Install Complete",
          align: "center",
          value: "fibrePulled"
        },
        {
          text: "Complex Street Name",
          align: "center",
          value: "complexStreetName"
        },
        {
          text: "Sub Complex",
          align: "center",
          value: "locationNetworkSubComplex.subComplexName"
        },
        {
          text: "Estate",
          align: "center",
          value: "complexName"
        }
      ]
    };
  },
  watch: {
    "$route.query.page": {
      immediate: true,
      handler(value) {
        this.page = value;
      }
    },
    selectedLocation(value) {
      const route = {
        name: this.$route.name
      };
      if(!this.$route.locationSearch){
      route.query = { selectedLocation: value.id, selectedDevice: "" };}
      else {
        route.query = { selectedLocation: value.id, selectedDevice: this.$route.query.selectedDevice };}
      
      this.$router.push(route);
      this.$emit("locationSearchCancelled");
    },
    "$route.query.limit": {
      immediate: true,
      handler(value) {
        this.limit = value;
      }
    },
    searchLocations(value) {
      
      const route = {
        name: this.$route.name
      };
      if(!this.customerId){
      if (this.searchLocations !== "") {
        if (this.locationNetworkId) {
          let networkId=this.locationNetworkId
        // this.locations=this.networklocations.filter(function(el){
        //   return el.locationNetworkId===networkId
        // })
          route.query = {
            searchLocations: this.searchLocations,
            locationNetworkId: this.locationNetworkId
          };
          // Api().get("/packagesIsps/allNetworks/" + this.locationNetworkId);
        } else {
          this.locations=this.networklocations
          route.query = {
            searchLocations: this.searchLocations
          };
        }
      } else if (this.locationNetworkId) {
        let networkId=this.locationNetworkId
        // this.locations=this.networklocations.filter(function(el){
        //   return el.locationNetworkId===networkId
        // })
        route.query = {
          locationNetworkId: this.locationNetworkId
        };
      } }else{
         if (this.searchLocations !== "") {
        if (this.locationNetworkId) {
          let networkId=this.locationNetworkId
        // this.locations=this.networklocations.filter(function(el){
        //   return el.locationNetworkId===networkId
        // })
          route.query = {
            searchLocations: this.searchLocations,
            locationNetworkId: this.locationNetworkId,
            customerId: this.customerid
          };
          // Api().get("/packagesIsps/allNetworks/" + this.locationNetworkId);
        } else {
          this.locations=this.networklocations
          route.query = {
            searchLocations: this.searchLocations,
            customerId: this.customerid
          };
        }
      } else if (this.locationNetworkId) {
        let networkId=this.locationNetworkId
        // this.locations=this.networklocations.filter(function(el){
        //   return el.locationNetworkId===networkId
        // })
        route.query = {
          locationNetworkId: this.locationNetworkId,
          customerId: this.customerid
        };
      } else {
        this.locations=this.networklocations
        route.query = { customerId: this.customerid };
      }
      }
      this.$router.push(route);
    },
   
    dialog(val) {
      val || this.close();
    },
   
    locationNetworkId(value) {
      const route = {
        name: this.$route.name
      };
      if(!this.customerId){
      if (this.searchLocations !== "") {
        route.query = {
          searchLocations: this.searchLocations,
          locationNetworkId: this.locationNetworkId
        };
      } else {
        route.query = {
          locationNetworkId: this.locationNetworkId
        };
      }}else{
         if (this.searchLocations !== "") {
        route.query = {
          searchLocations: this.searchLocations,
          locationNetworkId: this.locationNetworkId,
          customerId: this.customerid
        };
      } else {
        route.query = {
          locationNetworkId: this.locationNetworkId,
          customerId: this.customerid
        };
      }
      }
      this.$router.push(route);
    }
  },
  methods: {
   
    checkServiceAccountLocation(item){
      Api().get('/Locations/' + item.id).then(response=>{
           if (response.data[0].fibrePulled == false) {
        confirm("Please select a location with a complete passive installation.");
      }
        })
    },
     searchLocationInModel(search){
      if(search.search!==""){      
        Api()
        .get('/Locations',{
          params: {
          search: search.search,
         }
          })
        .then(response=>{
          this.locations=response.data
        })} 
      },
    recordCalculator(value) {
      return value + Math.ceil(this.pagination.rowsPerPage * (this.page - 1));
    },
    pager(value) {
      this.page = parseInt(this.page) + parseInt(value);
      this.pagination.page = this.page;
    },
    pageCount(totalItems, start, end) {
      if (typeof this.page === "undefined") {
        this.page = 1;
      }
      this.pages = Math.ceil(this.totalitems / this.pagination.rowsPerPage);
      this.limit = this.pagination.rowsPerPage;
      if (start - end === 0 && totalItems > 1) {
        this.limit = this.pagination.rowsPerPage;
      } else {
        this.limit = this.pagination.rowsPerPage;
      }
    },
    searchForLocation(search) {
      if(this.customerId == null){
      Api()
        .get("/locations", {
          params: {
            locations: search,
            limit: this.limit,
            page: this.page
          }
        })
        .then(response => {
          //this.networklocations = response.data;
          this.replacenetworklocations = response.data;
        });
        }else{
           Api()
        .get("/locations", {
          params: {
            locations: search,
            customerId: this.customerId,
            limit: this.limit,
            page: this.page
          }
        })
        .then(response => {
          //this.networklocations = response.data;
          this.replacenetworklocations = response.data;

        });
        }
    },
    searchForLocationWithinNetwork(search, networkId) {
       if(this.customerId == null){
      if (search) {
        Api()
          .get("/locations", {
            params: {
              locationSearch: search,
              locationNetworkId: networkId
            }
          })
          .then(response => {
            //this.networklocations = response.data;
               this.replacenetworklocations = response.data;
          });
      } else {
        Api()
          .get("/locations", {
            params: {
              locationNetworkId: networkId,
              limit: this.limit,
              page: this.page
            }
          })
          .then(response => {
            //this.networklocations = response.data;
               this.replacenetworklocations = response.data;
          });
      }
    }else{
      if (search) {
        Api()
          .get("/locations", {
            params: {
              locationSearch: search,
              locationNetworkId: networkId,
              customerId: this.customerId
            }
          })
          .then(response => {
            //this.networklocations = response.data;
               this.replacenetworklocations = response.data;
          });
      } else {
        Api()
          .get("/locations", {
            params: {
              locationNetworkId: networkId,
              customerId: this.customerId,
              limit: this.limit,
              page: this.page
            }
          })
          .then(response => {
            //this.networklocations = response.data;
               this.replacenetworklocations = response.data;
          });
         }
       }
      
    }
    
  }
};
</script>

